import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import {
    PageSection,
} from 'wanderu-components';

import localize from 'wanderu-i18n/src/localize';

import localesConfig from '../../../config/homepage.locales';
import links from './linkData.js';

import styles from './FeaturedInSection.scss';

function FeaturedInSection(props) {
    const {
        className,
        t,
    } = props;

    function _renderLink(linkObj) {
        const imgUrl = require(
            `wanderu-assets/images/homepage/pressIcons/${linkObj.imgSlug}.png`,
        );
        const imgUrlx2 = require(
            `wanderu-assets/images/homepage/pressIcons/${linkObj.imgSlug}-x2.png`,
        );

        return (
            <div
                className={styles.linkCell}
                key={linkObj.imgSlug}
            >
                <LazyLoad height={100}>
                    <img
                        alt={linkObj.alt}
                        className={styles.linkIcon}
                        height={100}
                        src={imgUrl}
                        srcSet={`${imgUrlx2} 2x`}
                        title={linkObj.alt}
                        width={187}
                    />
                </LazyLoad>
            </div>
        );
    }

    const linksArr = [
        Object.values(links).slice(0, 4),
        Object.values(links).slice(4, 8),
    ];

    return (
        <PageSection
            className={classNames(className, styles.container)}
        >
            {linksArr.map((linkRow, index) => {
                return (
                    <div
                        className={styles.linkRow}
                        key={index}
                    >
                        {linkRow.map(_renderLink)}
                    </div>
                );
            })}
            <p className={styles.andManyMore}>
                {t('and-many-more')}
            </p>
        </PageSection>
    );
}

FeaturedInSection.propTypes = {
    className: PropTypes.string,
};

export { FeaturedInSection };
export default localize(FeaturedInSection, localesConfig.namespace);
